module.exports = __webpack_public_path__ + "img/switch.0c1a28bf.svg";